class MobileDock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = document.querySelector('.shopify-section-header');

    this.isAction = false;
    this.scrollY  = header ? parseInt(header.getBoundingClientRect().bottom) : 0;

    if (Shopify && Shopify.designMode) {
      this.scrollY = 0;
    }

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));

    // Hide the always-on LiveChat launcher on mobile (opened via the dock Chat item).
    if (this.querySelector('.dock__item[data-action="chat"]')) {
      this.initLiveChat();
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();

    document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    document.addEventListener('matchSmall', () => {
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= this.scrollY) {
      this.classList.add('is-active');
    }
    else {
      this.classList.remove('is-active');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        if (miniCart) {
          setTimeout(() => {
            miniCart.open();
            document.activeElement.blur();
          }, delay);
        }
        else {
          window.location.href = theme.routes.cart_url;
        }
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        if (headerDrawer) {
          setTimeout(() => {
            headerDrawer.openMenuDrawer();
          }, delay);
        }
        break;

      case 'search':
        this.isAction = true;
        
        const searchModals = document.querySelectorAll('search-modal');
        if (searchModals.length > 0) {
          searchModals.forEach((searchModal) => {
            const style = window.getComputedStyle(searchModal);
            if (style.display === 'none') {
              return;
            }
  
            setTimeout(() => {
              searchModal.open();
              searchModal.querySelector('input:not([type="hidden"])').focus();
            }, delay);
          });
        }
        else {
          window.location.href = theme.routes.search_url;
        }
        break;

      case 'chat':
        this.openLiveChat();
        break;
    }
  }

  openLiveChat() {
    // Show a loading spinner on the Chat button — LiveChat can take a second or
    // two to open, so this confirms the tap registered. Cleared when the widget
    // reports 'maximized' (see initLiveChat), with a timeout as a safety net.
    const chatItem = this.querySelector('.dock__item[data-action="chat"]');
    if (chatItem) {
      chatItem.classList.add('is-loading');
      clearTimeout(this._lcLoadingTimer);
      this._lcLoadingTimer = setTimeout(() => chatItem.classList.remove('is-loading'), 8000);
    }

    // Reveal the launcher/window (mobile hides it via CSS until this class is set).
    document.body.classList.add('rs-chat-open');

    // `maximize` un-hides AND opens the LiveChat window from any state.
    if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
      window.LiveChatWidget.call('maximize');
      return;
    }
    // Legacy LiveChat API fallback (no visibility event, so clear immediately).
    if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
      window.LC_API.open_chat_window();
      if (chatItem) chatItem.classList.remove('is-loading');
    }
  }

  initLiveChat(attempt) {
    // The LiveChat launcher is "always visible" (needed on desktop, which has no
    // mobile dock). On mobile the launcher is hidden via inline CSS in the <head>
    // (body:not(.rs-chat-open) #chat-widget-container) so there's no launcher
    // flash; the dock's Chat button reveals it (adds body.rs-chat-open). Here we
    // just re-hide it (remove the class) when the visitor closes/minimizes the
    // chat, and clear the Chat button's spinner once it has opened.
    attempt = attempt || 0;
    const widget = window.LiveChatWidget;

    // The widget script loads async — wait for its API before wiring up.
    if (!widget || typeof widget.on !== 'function') {
      if (attempt < 25) {
        setTimeout(() => this.initLiveChat(attempt + 1), 300);
      }
      return;
    }
    if (this._lcReady) return;
    this._lcReady = true;

    try {
      widget.on('visibility_changed', (data) => {
        if (!data) return;
        if (data.visibility === 'maximized') {
          const chatItem = this.querySelector('.dock__item[data-action="chat"]');
          if (chatItem) chatItem.classList.remove('is-loading');
          clearTimeout(this._lcLoadingTimer);
        }
        else {
          // minimized/hidden → re-hide the launcher on mobile (CSS-driven).
          document.body.classList.remove('rs-chat-open');
        }
      });
    } catch (e) {}
  }

  hideStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (theme.config.mqlSmall && this.isAction && header.sticky()) {
      setTimeout(() => {
        header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  waitStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (!header.sticky() && !this.isElementVisible(header)) {
      header.hide();
      setTimeout(() => header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
customElements.define('mobile-dock', MobileDock);
